import { render, staticRenderFns } from "./ProductModalBarcode.vue?vue&type=template&id=212c4d9e"
import script from "./ProductModalBarcode.vue?vue&type=script&lang=js"
export * from "./ProductModalBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports